import CurrencyModel from "./CurrencyModel";
import LocalStorageCollection from "../prototypes/LocalStorageCollection";
import ObjectCollection from "../prototypes/ObjectCollection";
// Collection Configuration
//

class CurrencyCollection extends ObjectCollection<CurrencyModel> {
  name = "CurrencyCollection";
  route = "apiCurrencyCollection";
  idAttribute = "id_currency";

  initialize(models: Record<string, any>[] | CurrencyModel[], o: any) {
    const model = this;
    // ObjectCollection constructor heritage
    super.initialize.apply(model, [models, o]);
  }
}
CurrencyCollection.prototype.url = () => "/currency";
CurrencyCollection.prototype.model = CurrencyModel;

export default CurrencyCollection;
